import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { RegistrationUserFormGroup } from './auth-user-form-group.interface';
import { Injectable, inject } from '@angular/core';
import { hasDigit, hasLowerCase, hasNonAlphaNumeric, hasUpperCase } from '../../validators/password-validators';

@Injectable()
export class RegistrationUserFormModel {
  readonly fieldNames = {
    email: 'email',
    password: 'password',
    interfaceLanguage: 'interfaceLanguage',
  };

  form: FormGroup<RegistrationUserFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<RegistrationUserFormGroup>({
      email: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.email],
      }),
      password: new FormControl('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.minLength(6),
          hasDigit,
          hasLowerCase,
          hasUpperCase,
          hasNonAlphaNumeric
        ],
      }),
      interfaceLanguage: new FormControl()
    });
  }
}
